import type { ReactNode } from "react";

export interface AnalyticsHeaderProps {
  /** Rótulo en versalitas sobre el título ("Lectura financiera mensual"). */
  overline: string;
  /** Líneas del título ("Hey," / "Analítica!"). Es el único h1 de la página. */
  title: string[];
  /** Frase de contexto bajo el título, según la vista activa. */
  subtitle?: string;
  /** Control a la derecha del título (ciclo, modo de lectura). Vacío = no se renderiza. */
  aside?: ReactNode;
}

/** Encabezado de Analítica: rótulo, título grande y frase; el control va a la derecha en md+. */
export function AnalyticsHeader({ overline, title, subtitle, aside }: AnalyticsHeaderProps) {
  return (
    <header className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between md:gap-10">
      <div className="min-w-0">
        <p className="m-0 mb-3 text-[11px] font-medium uppercase leading-[14px] tracking-[0.18em] text-[var(--ds-ink-muted)]">
          {overline}
        </p>
        <h1 className="m-0 font-[var(--ds-font-display)] text-[clamp(40px,8vw,88px)] font-normal leading-[0.95] tracking-[-0.04em] text-[var(--ds-ink)]">
          {title.map((line) => (
            <span key={line} className="block break-words">{line}</span>
          ))}
        </h1>
        {subtitle && <p className="m-0 mt-4 text-base leading-6 text-[var(--ds-ink-muted)] md:text-lg md:leading-[26px]">{subtitle}</p>}
      </div>
      {aside && <div className="flex flex-none items-center">{aside}</div>}
    </header>
  );
}
